<template>
  <div class="ui grid">
    <div class="three wide column"> 
      <div class="ui secondary vertical pointing menu" style="width: 100%">
        <a class="item" :class="{ active: currentTab === tabs.first }"
              @click="currentTab = tabs.first">
          Prescriptions
        </a>
        <a class="item" :class="{ active: currentTab === tabs.second }"
              @click="currentTab = tabs.second">
          Diagnoses
        </a>
        <a class="item" :class="{ active: currentTab === tabs.third }"
              @click="currentTab = tabs.third">
          Medical tests
        </a>
        <a class="item" :class="{ active: currentTab === tabs.fourth }"
              @click="currentTab = tabs.fourth">
          Follow ups
        </a>
        <a class="item" :class="{ active: currentTab === tabs.fifth }"
              @click="currentTab = tabs.fifth">
          Images
        </a>
      </div>
    </div>
    <div class="thirteen wide column"> 
      <prescriptions :prescriptions="getData()" v-if="currentTab === tabs.first" />

      <diagnoses :diagnoses="getData()" v-if="currentTab === tabs.second" />

      <medicalAnalysis :medicalAnalysis="removeEmpty(getData())" v-if="currentTab === tabs.third" />

      <followUps 
        :followUps="removeEmpty(getData())" 
        v-if="currentTab === tabs.fourth" 
        class="center aligned centered"
      />  
      <images :imagesProp="removeEmpty(getData())" v-if="currentTab === tabs.fifth" />
    </div>
  </div>
</template>

<script>
export default {
  components: {
    prescriptions: require('./medical_history_components/Prescriptions').default,
    diagnoses: require('./medical_history_components/Diagnoses').default,
    medicalAnalysis: require('./medical_history_components/MedicalAnalysis').default,
    followUps: require('./medical_history_components/FollowUps').default,
    images: require('./medical_history_components/Images').default
  },
  props: {
    visits: { type: Array, required: true }
  },
  data() {
    return {
      tabs: {
        first: 'prescription',
        second: 'diagnose',
        third: 'medical_analysis',
        fourth: 'follow_up',
        fifth: 'images'
      },
      currentTab: 'prescription'
    }
  },
  methods: {
    getData() {
      return this.patientDataOf(this.currentTab)
    },
    patientDataOf (currentTab) {
      return window._.flatten(window._.map(this.visits, currentTab))
    },
    removeEmpty(data) {
      return window._.filter(data, o => o && 'id' in o)
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/patients/patient_log_componenets/MedicalHistory.vue